import React from 'react';
import styled from 'styled-components';
import MySampleChapterList, {LinkButton} from './mySampleChapterList';

const Page = styled.main`
  margin: 0 auto;
  max-width: 900px;
  padding: var(--br-space-4);
`;

const Header = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--br-space-3);
  justify-content: space-between;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--br-space-2);
`;

const SampleChaptersHome = () => (
  <Page>
    <Header>
      <h1>Sample chapters (Chapter 1 tester)</h1>
      <Actions>
        <LinkButton to='/sample-chapters/discover'>Browse</LinkButton>
        <LinkButton to='/sample-chapters/new' variant='primary'>New sample</LinkButton>
      </Actions>
    </Header>
    <p>
      Publish only the first chapter of your book — text, audio, or both — and let
      readers tell you whether they would keep reading. Create multiple variants
      of the same chapter to A/B test alternatives.
    </p>
    <MySampleChapterList />
  </Page>
);

export default SampleChaptersHome;
